import Vue from 'vue'
import router from './router'
import App from './App.vue'
import Argon from './plugins/argon-kit'
import VueGtm from 'vue-gtm'

Vue.config.productionTip = false
Vue.use(Argon)
Vue.use(VueGtm, {
  id: 'GTM-M3HNN49',
  debug: false,
  loadScript: true,
  vueRouter: router
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
